import React from 'react';
import { Modal } from 'antd-mobile';

class Component extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: this.props.visible,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ visible: nextProps.visible });
    }

    render() {
        const { title } = this.props;
        return (
            <Modal
                className="modal"
                visible={this.state.visible}
                transparent
                maskClosable={false}
                title={title}
                footer={[{
                    text: '确定',
                    onPress: () => {
                        this.setState({ visible: false }, () => {
                            this.props.onPress && this.props.onPress();
                        });
                    },
                }]}
            >
                <div className="content">
                    {this.props.content}<br />
                </div>
            </Modal>
        );
    }
}

Component.defaultProps = {
    title: '标题',
    content: '内容',
    visible: false,
};

export default Component;



// WEBPACK FOOTER //
// ./src/components_common/Modal/BasicModal.js